import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/Users/xuxun/Documents/projects/xx/antd-utils/node_modules/gatsby-theme-docz/src/base/Layout.js";
import { Enum2Options } from './enum2options';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <h1 {...{
      "id": "enum-2-options"
    }}>{`Enum 2 Options`}</h1>
    <Enum2Options mdxType="Enum2Options" />
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`
import React, { FC } from 'react'
import { Select, Form } from 'antd'
import 'antd/dist/antd.css'
import { enum2Options } from 'antd-utils'

// notice: Don't use Number as index of the Enum, or the ts-lint would throw error 
// (also numberic index will be filter out in enum2Options function)

enum ESelectOptions {
  option0 = 0,
  optionA = "a",
  optionTest = "test",
  // 0 = a , // sorry it's invalid
}

const options = enum2Options(ESelectOptions)

export const Enum2Options: FC = () => {

  return (
    <>
      <Form>
        <Form.Item name="name">
          <Select>
            {
              (options || []).map((item: any) => (
                <Select.Option key={item.value} value={item.value}>{item.label}</Select.Option>
              ))
            }
          </Select>
        </Form.Item>
      </Form>
    </>
  )
}
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      